

































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Validation } from 'vuelidate';

@Component({
	components: {},
})
export default class SiteLookup extends Vue {
	@Prop({
		default: () => {
			return { lat: '', lng: '' };
		},
	})
	public value?: { lat: string; lng: string };

	@Prop(Object)
	public readonly validator?: Validation;

	get validationState() {
		if (this.validator) {
			// @ts-ignore
			return (
				(this.validator.lat.$dirty && this.validator.lat.$invalid) ||
				(this.validator.lng.$dirty && this.validator.lng.$invalid)
			);
		}
		return null;
	}
}
